import { render } from "./SuscripcionForm.vue?vue&type=template&id=3f08ef13&scoped=true"
import script from "./SuscripcionForm.vue?vue&type=script&lang=js"
export * from "./SuscripcionForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=3f08ef13&scoped=true&lang=css"
import "@/assets/css/listaFiltrada.css?vue&type=style&index=1&id=3f08ef13&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f08ef13"]])

export default __exports__